// TODO: This component should be refactored. (clean and split codes)
import React, { FC, useEffect, useState } from 'react';
import { setLocalStorage } from '@/common/localStorages';
import { Icon } from '@/components/atomic/Icon';
// import { useAPI } from '@/services/index';
import Button from '@/components/Button';
import { useOpenBottomSheet } from '@/containers/UpdateContainer/components/BottomSheet';
import useForceUpdate from '@/hooks/forceUpdate';
import { useLogSlideEvent } from '../hooks/useLogSlideEvent';
import { getAppVersion } from '@/utils/application';
import { classnames } from '@/common/utils/classnames';
// import { convertToGUID } from '@/common/utils/string';
import { IStory, IStorySlide } from '../../Story/Story.type';
import { Divider } from '../../Divider';
import openHintBottomSheet from '../HintBottomSheet';

const STORAGE_KEY = 'app_version';

interface IHintSliderProps {
  chosenSlide: IStorySlide;
  chosenStory: IStory;
  setSliderId: (__id: string) => void;
  refetchStories: () => void;
  isChangelog?: boolean;
  highlightNumber?: number;
}

export const HintSlider: FC<IHintSliderProps> = ({
  chosenSlide,
  chosenStory,
  setSliderId,
  isChangelog = false,
  highlightNumber,
}) => {
  useEffect(() => {
    setSliderId(chosenStory?.slides?.[0]?.id);
  }, []);

  const { logSlideEvent } = useLogSlideEvent(isChangelog);

  const [shouldShowMore, setShouldShowMore] = useState(false);
  const currentStorySlideIndex = chosenStory?.slides?.findIndex(
    (item) => item?.id === chosenSlide?.id
  );
  const nextSlideId = chosenStory?.slides?.[currentStorySlideIndex + 1]?.id;
  const prevSlideId = chosenStory?.slides?.[currentStorySlideIndex - 1]?.id;

  const handleSlideChange = (slideId: string) => () => {
    if (slideId) {
      setShouldShowMore(false);
      setSliderId(slideId);
    } else {
      closeAction();
    }
  };

  //* For logging event analytics
  useEffect(() => {
    const slideNumber = currentStorySlideIndex + 1;
    logSlideEvent(highlightNumber, slideNumber);
  }, [currentStorySlideIndex]);

  const toggleShouldShowMore = () => {
    setShouldShowMore((prevState) => !prevState);
  };

  const forceUpdate = useForceUpdate();
  const openChangelogBottomsheet = useOpenBottomSheet({
    onClose: () => {
      setLocalStorage(STORAGE_KEY, getAppVersion() as string);
      forceUpdate();
    },
  });

  const closeAction = () => {
    if (isChangelog) {
      openChangelogBottomsheet();
    } else {
      openHintBottomSheet({ shouldOpenFullPage: false });
    }
  };

  // const { mutateAsync } = useAPI(['baseInfo', 'addSlideVisit'], {
  //   isMutation: true,
  // });

  // useEffect(() => {
  //   if (!chosenSlide?.isSeen) {
  //     mutateAsync({ Slide: [convertToGUID(chosenSlide?.id)] }).then(() => {
  //       refetchStories();
  //     });
  //   }
  // }, [chosenSlide]);

  return (
    <div className="relative flex h-full flex-col">
      <div
        className="absolute left-[15px] top-[15px] z-10 flex h-8 w-8 items-center justify-center rounded-lg bg-gray-filledinvert-primary-enabled"
        onClick={closeAction}
      >
        <Icon color="#000000" icon="close" size={16} />
      </div>
      <img
        alt={chosenSlide?.buttonText}
        className="absolute right-0 top-0 h-[65vh] w-full object-cover"
        src={chosenSlide?.url}
      />
      <div
        className={classnames(
          'z-10 mt-auto flex min-h-[40vh] flex-col rounded-tl-xl rounded-tr-xl bg-white p-5 transition-all',
          shouldShowMore && 'min-h-[90vh]'
        )}
      >
        {chosenStory?.slides?.length > 1 && (
          <div className="mb-2 flex gap-x-1">
            {chosenStory?.slides.map((item) => (
              <div
                key={item?.id}
                className={classnames(
                  'h-1 w-6 rounded',
                  chosenSlide?.id === item?.id
                    ? 'bg-mofidblue-filled-primary-enabled'
                    : 'bg-neutral-filled-primary-enabled'
                )}
                onClick={handleSlideChange(item?.id)}
              ></div>
            ))}
          </div>
        )}
        <div
          dangerouslySetInnerHTML={{
            __html: shouldShowMore
              ? (chosenSlide?.fullText ?? '')
              : (chosenSlide?.summaryText ?? ''),
          }}
          className="mt-2"
        ></div>
        <div className="absolute bottom-4 right-4 z-10 flex w-[calc(100%-32px)] flex-col bg-white pt-3">
          {chosenSlide?.fullText && (
            <div
              className="mb-3 flex items-center justify-center text-xs font-medium text-mofidblue-filled-primary-enabled"
              onClick={() => setShouldShowMore(!shouldShowMore)}
            >
              {!shouldShowMore ? 'مشاهده بیشتر' : 'مشاهده کمتر'}

              <Icon
                icon={!shouldShowMore ? 'chevron_down' : 'chevron_up'}
                size={20}
              />
            </div>
          )}
          <Divider className="mb-3" />
          <div className="flex gap-x-2">
            {shouldShowMore ? (
              <Button size="lg" isFullWidth onClick={toggleShouldShowMore}>
                متوجه شدم
              </Button>
            ) : (
              <>
                <Button
                  size="lg"
                  isFullWidth
                  onClick={handleSlideChange(nextSlideId)}
                >
                  {!nextSlideId ? 'متوجه شدم' : 'بعدی'}
                </Button>
                {(nextSlideId || prevSlideId) && (
                  <Button
                    size="lg"
                    variant="outline"
                    isFullWidth
                    onClick={handleSlideChange(prevSlideId)}
                  >
                    {!prevSlideId ? 'متوجه شدم' : 'قبلی'}
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
